{
    "Profile_CommonComponents_Signature.signDocs": "FR: Sign docs",
    "Profile_CommonComponents_Signature.instructions": "FR: Sign in the box below with a cursor or finger.",
    "Profile_CommonComponents_Signature.errorMessage": "FR: Please Sign in the box before clicking save.",
    "Profile_CommonComponents_Signature.save": "FR: Save",
    "Profile_CommonComponents_Signature.clear": "FR: Clear",
    "Profile_CommonComponents_Signature.cancel": "FR: Cancel"
}
